import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import config from '@nerdwallet/app-config';
import { fetch } from 'whatwg-fetch';
import typePolicies from '../type-policies';
import { InMemoryCache, BROWSER_KEY } from '..';
import getApolloClient, { getPossibleTypes } from './shared';
/**
 * Light wrapper around the shared apollo-client implementation
 *
 * @param {object} [options]
 * @return {object} [ApolloClient]
 */

export default (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return getApolloClient(_objectSpread(_objectSpread({}, options), {}, {
    cache: new InMemoryCache({
      possibleTypes: getPossibleTypes(options),
      typePolicies: typePolicies
    }).restore(window[BROWSER_KEY]),
    // eslint-disable-next-line no-console
    log: function log(msg) {
      return config.DEBUG && console.warn(msg);
    },
    fetch: fetch
  }));
});